import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export interface IBooleanColumn extends ITableColumn {
  Settings: null
}

export interface IBooleanCell extends ICell {
  settings: null
}

const TRUE_VALUES = ['true', 'yes', 'on', '1', 'y', 'enabled', 'checked']

const FALSE_VALUES = ['false', 'no', 'off', '0', 'n', 'disabled', 'unchecked']

const BOOLEAN_VALUES = [...TRUE_VALUES, ...FALSE_VALUES]

export function isValidBoolean(value: unknown): value is boolean {
  if (typeof value === 'undefined' || value === null) {
    return false
  }
  if (typeof value === 'boolean') {
    return true
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return BOOLEAN_VALUES.includes(value.toString().toLowerCase())
  }
  return false
}

export function parseBooleanValue(value: unknown): boolean | null {
  if (typeof value === 'undefined' || value === null) {
    return null
  }
  if (typeof value === 'boolean') {
    return Boolean(value)
  }

  if (typeof value === 'string' || typeof value === 'number') {
    let strValue = value.toString().toLowerCase()

    switch (true) {
      case TRUE_VALUES.includes(strValue):
        return true
      case FALSE_VALUES.includes(strValue):
        return false
      default:
        return null
    }
  }
  return null
}

export class BooleanCell implements IBooleanCell {
  value: Cell
  settings: null

  constructor(value: Cell, settings: null) {
    this.value = isValidBoolean(value) ? parseBooleanValue(value) : null
    this.settings = settings
  }

  toString(): string {
    if (this.value === true) {
      return 'TRUE' // or 'Yes' if preferred
    } else if (this.value === false) {
      return 'FALSE' // or 'No' if preferred
    }
    return '' // Handle null or any unsupported types gracefully
  }

  toCell<T extends Cell>(value: T) {
    this.value = value
    return this
  }
}
